<template>
  <div class="thesaurus">
    <div class="thesaurus-left">
      <el-alert
        class="title"
        title="添加"
        type="success"
        :closable="false"
      />
      <el-form ref="form" :model="form" label-width="auto">
        <el-form-item label="正词">
          <el-input v-model="form.name" size="mini" @input="changeName" />
        </el-form-item>
        <el-form-item label="语境">
          <el-input type="textarea" v-model="form.desc"  size="mini" />
        </el-form-item>
      </el-form>
      <div class="btns">
        <base-upload  @txtContent="getTxtContent" />
        <el-button type="primary" size="small" @click="add">添加</el-button>
      </div>
    </div>
    <div class="thesaurus-right">
      <el-alert
        class="title"
        title="查询"
        type="success"
        :closable="false"
      />
      <el-row :gutter="20">
        <el-col :span="18">
          <el-input v-model="query"  size="mini" />
        </el-col>
        <el-col :span="6">
          <el-button size="mini" @click="handleQuery">查询</el-button>
        </el-col>
      </el-row>
      <base-table
        :tableTitle="tableTitle"
        :tableData="tableData"
      >
      <template v-slot:operation="{ rowDate }">
        <el-button type="primary" size="mini" @click="showDialog(rowDate)">修改</el-button>
        <el-button type="danger" size="mini" @click="removeRow(rowDate)">删除</el-button>
      </template>
      </base-table>
      <base-pagination
        :total.sync="tableData.length"
        :page.sync="params.page"
        :limit.sync="params.size"
        @pagination="changePage"
      />
    </div>

    <!-- 修改弹窗 -->
    <base-dialog
      :title="dialog.title"
      :visible.sync="dialog.visible"
      :formRules="dialog.formRules"
      :formData.sync="dialog.params"
      @submit="updateSubmit"
    />
  </div>
</template>

<script>
import BaseTable from '@/components/BaseTable/index';
import BasePagination from '@/components/BasePagination/index';
import BaseDialog from '@/components/BaseDialog/index';
import BaseUpload from '@/components/BaseUpload/index';
import {
  getThesaurus,
  deleteThesaurus,
  addThesaurus,
  modifyThesaurus,
} from '@/api/index';

export default {
  name: 'thesaurus',
  components: {
    BaseTable,
    BasePagination,
    BaseDialog,
    BaseUpload,
  },
  data() {
    return {
      form: {
        name: '',
        desc: '',
      },
      query: '',
      tableTitle: [{
        label: '正词',
        prop: 'right_word',
      },
      {
        label: '语境',
        prop: 'context',
      },
      {
        label: '增加日期',
        prop: 'add_time',
      },
      {
        label: '操作',
        prop: 'operation',
        width: 150
      }],
      tableData: [],
      params: {
        total: 0,
        page: 1,
        size: 10,
      },
      userJson: {},
      dialog: {
        title: '修改正词库',
        visible: false,
        formRules: [{
          name: '正词库',
          prop: 'new_right_word',
          inputType: 'text',
          rules: [{ required: true, message: '不能为空', trigger: 'blur' }],
        },
        {
          name: '语境',
          prop: 'new_context',
          inputType: 'textarea',
          rules: [{ required: true, message: '不能为空', trigger: 'blur' }],
        }],
        params: {
          context: '',
          right_word: '',
          new_right_word: '',
          new_context: '',
        },
      },
    };
  },
  created() {
    this.$nextTick(() => {
      const { wps } = localStorage;
      this.userJson = JSON.parse(wps);
      this.getList();
    })
  },
  methods: {
    changeName(val) {
      console.log(val);
      this.form.desc = val;
    },
    handleQuery() {
      this.params = {
        total: 0,
        page: 1,
        size: 10,
      }
      this.tableData = [];
      this.getList();
    },
    async getList() {
      //  const { user: { pwd, userid } } = JSON.parse(localStorage.wps);
      const res = await getThesaurus({
        word: this.query,
        page_no: this.params.page,
        token: this.userJson.token,
      });
      this.tableData = res || [];
    },
    async add() {
      const { name, desc } = this.form;
      const res = await addThesaurus({
        right_word: name,
        context: desc,
        user_code: this.userJson.user.userid,
        token: this.userJson.token,
      });
      if(res.return_code == 0) {
        this.$message({
          message: res.return_msg,
          type: 'success'
        });
      } else {
        this.$message({
          message: res.return_msg,
          type: 'error'
        });
      }
      this.params.page = 1;
      this.getList();
    },
    async removeRow(row) {
      const { right_word, context} = row;
      const res = await deleteThesaurus({
        right_word,
        context,
        token: this.userJson.token,
      });
      if(res.return_code == 0) {
        this.$message({
          message: res.return_msg,
          type: 'success'
        });
      }
      this.getList();
    },
    changePage() {
      this.getList();
    },
    async updateSubmit(val) {
      const {
        right_word,
        new_right_word,
        context,
        new_context,
      } = val;
      const res = await modifyThesaurus({
        right_word,
        new_right_word,
        context,
        new_context,
        token: this.userJson.token,
      });
      if(res.return_code == 0) {
        this.$message({
          message: res.return_msg,
          type: 'success'
        });
        this.dialog.visible = false;
      }
      this.getList();
    },
    showDialog(row) {
      const { context, right_word } = row
      this.dialog = {
        ...this.dialog,
        visible: true,
        params: {
          ...row,
          new_right_word: right_word,
          new_context: context,
        }
      }
    },
    getTxtContent(list) {
      list.forEach((item) => {
        this.import_(item);
      });
    },
    async import_(item) {
      if(item.length < 2) {
        this.$message({
          message: '文件格式错误！',
          type: 'error'
        })
        return;
      }
      const res = await addThesaurus({
        right_word: item[0],
        context: item[1],
        user_code: this.userJson.user.userid,
        token: this.userJson.token,
      });

      if(res.return_code == 1) {
        this.$message({
          message: res.msg,
          type: 'error'
        })
      }
      this.params.page = 1;
      this.getList();
    }
  }
};
</script>

<style scoped>
.thesaurus {
  height: 100%;
  display: flex;
  box-sizing: border-box;
  padding: 20px;
}

::v-deep .el-input__inner,
::v-deep .el-textarea__inner {
  color: black;
}

.thesaurus-left  {
  flex: 1;
}

.thesaurus-right {
  /* padding-left: 30px; */
  width: 60%;
}

.thesaurus-left  {
  margin-right: 50px;
}

.title {
  margin-bottom: 12px;
}
::v-deep .el-textarea__inner {
  min-height: 200px!important;
}

.btns {
  display: flex;
  justify-content: flex-end;
}
</style>